<template>
  <div class="layout">
    <Header v-if="!$fromApp"/>
    <div id="content-wrapper">
      <slot/>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.layout {
  overflow: hidden;
}
#content-wrapper {
  min-height: calc(100vh - 286px);
  padding-bottom: 30px;
}
</style>
